// const standardS3Url = "https://gamechangecrate.s3.amazonaws.com";
const cloudfrontUrl = "https://dbzu0dbyqmpqn.cloudfront.net";

export const s3url = cloudfrontUrl;
